import { render, staticRenderFns } from "./AddBodyguard.vue?vue&type=template&id=1b7f3d60&"
import script from "./AddBodyguard.vue?vue&type=script&lang=js&"
export * from "./AddBodyguard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports